import type { Page } from '../../types';
import { getColumns, getKeys, getRows } from '../../../components/form/CoreTthConsolidatedInput';

const timeToHire: Page[] = [
  {
    pageType: 'information',
    title: 'Before you start',
    name: 'before-you-start',
    continueConfirmation: 'I have read and understand the guidance',
    description: `
	  <strong>Overview</strong><br>
	  Time To Hire is used to evaluate the efficiency of the selection process from a candidate perspective. This is a subset of the overall recruitment process defined as Time To Fill. Time To Hire covers the number of days between the date a vacancy advert closes and the date a provisional offer is made to the candidate. This standardised Workforce Reform Directorate (WRD) definition was agreed by HR Directors at the HR Steering Board in September 2023. The WRD definition focuses specifically on the candidate perspective of the selection and assessment process and provides the best opportunity to measure a critical part of the recruitment process in a way that is fair and comparable within the Civil Service and with external organisations. To do this, Time To Hire omits certain stages of the recruitment process, for example: vetting levels vary by departmental role composition and are not commonplace in external organisations; advertising time can vary for strategic attraction reasons; notice periods are not within the control of vacancy managers. Time To Hire measurements should be classified and monitored according to the grade structure of the department.<br><br>

	  <strong>Methodology</strong><br>
	  Time To Hire should be calculated by the number of days that elapse between the date a vacancy advert closes and the date a provisional offer is made to the candidate. Rolling campaigns without an advert closing date should use the date that the successful candidate submitted their application as the starting point if possible. Average Time To Hire should be calculated as a median average. The median average is the middle number in a sequence of values, e.g. 4 is the median of 1, 3, 4, 8, 9. Use of the median average better accommodates outlier values caused by data quality issues or abnormal campaigns.<br><br>

	  <strong>Campaigns to be included</strong><br>
	  Campaigns to be included in the calculation are those that have concluded within the specified reporting period (e.g. where an offer is made in Q4, Jan-Mar 2023/24). Campaigns for permanent and temporary roles should be included in the Time To Hire calculation. It should also include those where an offer was made but the candidate later withdrew prior to the start date. Campaigns based on an Expression of Interest, reserve list appointment, or where no successful candidate is identified, should be omitted.
	`,
  },
  {
    pageType: 'question',
    title: 'Time to Hire',
    name: 'time-to-hire',
    questions: [
      {
        questionType: 'CoreTthConsolidatedInput',
        title: 'Median Time to Hire measurements in Calendar Days',
        name: 'tth-median',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments and observations',
        name: 'tth-comments',
        hint:
          'Please outline any factors that may explain quarter-on-quarter change or influence these reported figures.',
        rules: {
          required: false,
        },
      },
   		{
        questionType: 'textarea',
        title: 'Progress towards benchmark',
        name: 'tth-benchmark',
        hint: 'What action has been taken in the last quarter to move toward the benchmark.',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default timeToHire;
